module.exports = __webpack_public_path__ + "Raleway-700-Bold-Italic.c7a4548f69aa83778b84.ttf";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/assets/fonts/Raleway-700-Bold-Italic.ttf
// module id = ../../../../../src/assets/fonts/Raleway-700-Bold-Italic.ttf
// module chunks = styles